export const emailRules = [
  v => Boolean(v) || "Email is required",
  v =>
    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Email must be valid"
];

export const passwordRules = [v => Boolean(v) || "Password is required"];


// WEBPACK FOOTER //
// ./src/validation/rules.js